import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {dialogueAsyncActions, startXpedition, getTranslations, restartXpedition} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import {ReactComponent as XpeditionIcon} from 'assets/image/menu-auth/DISCOVERY_GABI1.svg';

import './styles.scss';
import {useNavigate, useParams} from 'react-router-dom';
import {BotMode} from '@wholesalechange/chatcomponent';

export const XpeditionChat: React.FunctionComponent = () => {
  const {
    dialogue
  } = useSelector((state: IStore) => state.dialogue);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const [dialogueId, setDialogueId] = useState<number>();
  const {xpeditionId, restart} = useParams();
  const history = useNavigate();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogue) {
      setDialogueId(dialogue.id);
    }
  }, [dialogue]);

  useEffect(() => {
    if (xpeditionId) {
      if (restart === 'restart') {
        dispatch(dialogueAsyncActions[restartXpedition](Number(xpeditionId)));
        history(`/xpedition/${xpeditionId}`, {replace: true});
      } else {
        dispatch(dialogueAsyncActions[startXpedition](Number(xpeditionId)));
      }
    }
  }, [xpeditionId]);

  useGetTranslations({
    translationKey: TranslationKeys.Chat
  });

  return <div className="xpedition">
    {
      !loading.includes(getTranslations) && <>
        <h1 className="xpedition__title">
          <XpeditionIcon className="xpedition__icon"/>
          <FormattedMessage
            id={'gritx.xpedition.title'}
            defaultMessage={'Xpedition'}
          /> {dialogue && <span className="xpedition__title-dialogue-name"> - {dialogue.name}</span>}
        </h1>
        <BotChat chatType={BotType.Xpedition} chatMode={BotMode.NoHistory} dialogueId={dialogueId}
          title={dialogue?.name || ''}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
